import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="signup-container">
        <div className="add-a-course-form-container" style={{ width: "800px", fontSize: "14px", color: "var(--almost-black)"}}>
      <h1 >Terms and Conditions</h1>

      <p>These terms and conditions outline the rules and regulations for the use of GoValuate's Website, located at GoValuate.com. The following rules as regulations apply to our website and mobile apps, even if it is not explicitly stated.</p>

      <p>By accessing this website we assume you accept these terms and conditions. Do not continue to use GoValuate if you do not agree to take all of the terms and conditions stated on this page.</p>

      <div >
        <h2>1. Terminology</h2>
        <p>The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements:</p>
        <ul>
          <li>“Client”, “You” and “Your” refers to you, the person log on this website and compliant to the Company's terms and conditions.</li>
          <li>“The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our Company.</li>
          <li>“Party”, “Parties”, or “Us”, refers to both the Client and ourselves.</li>
        </ul>
        <p>All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client's needs in respect of provision of the Company's stated services, in accordance with and subject to, prevailing law of the United States of America. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.</p>
      </div>

      <div>
        <h2 >2. Cookies</h2>
        <p>We employ the use of cookies. By accessing GoValuate, you agreed to use cookies in agreement with the GoValuate's Privacy Policy.</p>
        <p>Most interactive websites use cookies to let us retrieve the user's details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website.</p>
      </div>

      <div >
        <h2 >3. License</h2>
        <p>Unless otherwise stated, GoValuate and/or its licensors own the intellectual property rights for all material on GoValuate. All intellectual property rights are reserved. You may access this from GoValuate for your own personal use subjected to restrictions set in these terms and conditions.</p>
        <p>You must not:</p>
        <ul>
          <li>Republish material from GoValuate</li>
          <li>Sell, rent or sub-license material from GoValuate</li>
          <li>Reproduce, duplicate or copy material from GoValuate</li>
          <li>Redistribute content from GoValuate</li>
        </ul>
        <p>This Agreement shall begin on the date hereof.</p>
      </div>

      <div>
        <h2 >4. User Comments</h2>
        <p>Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the GoValuate. GoValuate does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of GoValuate, its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, GoValuate shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.</p>
        <p>GoValuate reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.</p>
        <p>You warrant and represent that:</p>
        <ul>
          <li>You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;</li>
          <li>The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party;</li>
          <li>The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy;</li>
          <li>The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity.</li>
        </ul>
        <p>You hereby grant GoValuate a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media.</p>
      </div>

      <div>
        <h2>5. Hyperlinking to Our Content</h2>
        <p>The following organizations may link to our Website without prior written approval:</p>
        <ul>
          <li>Government agencies;</li>
          <li>Search engines;</li>
          <li>News organizations;</li>
          <li>Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses;</li>
          <li>System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site.</li>
        </ul>
        <p>These organizations may link to our home page, to publications or to other Website information so long as the link:</p>
        <ul>
          <li>Is not in any way deceptive;</li>
          <li>Does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services;</li>
          <li>Fits within the context of the linking party's site.</li>
        </ul>
        <p>We may consider and approve other link requests from the following types of organizations:</p>
        <ul>
          <li>Commonly-known consumer and/or business information sources;</li>
          <li>Dot.com community sites;</li>
          <li>Associations or other groups representing charities;</li>
          <li>Online directory distributors;</li>
          <li>Internet portals;</li>
          <li>Accounting, law and consulting firms; and</li>
          <li>Educational institutions and trade associations.</li>
        </ul>
        <p>We will approve link requests from these organizations if we decide that:</p>
        <ul>
          <li>The link would not make us look unfavorably to ourselves or to our accredited businesses;</li>
          <li>The organization does not have any negative records with us;</li>
          <li>The benefit to us from the visibility of the hyperlink compensates the absence of GoValuate; and</li>
          <li>The link is in the context of general resource information.</li>
        </ul>
        <p>These organizations may link to our home page so long as the link:</p>
        <ul>
          <li>Is not in any way deceptive;</li>
          <li>Does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services;</li>
          <li>Fits within the context of the linking party's site.</li>
        </ul>
        <p>If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by sending an e-mail to GoValuate. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.</p>
        <p>Approved organizations may hyperlink to our Website as follows:</p>
        <ul>
          <li>By use of our corporate name; or</li>
          <li>By use of the uniform resource locator being linked to; or</li>
          <li>By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking party's site.</li>
        </ul>
        <p>No use of GoValuate's logo or other artwork will be allowed for linking absent a trademark license agreement.</p>
      </div>

      <div>
        <h2>6. iFrames</h2>
        <p>Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.</p>
      </div>

      <div >
        <h2 >7. Content Liability</h2>
        <p>We shall not be held responsible for any content that appears on GoValuate. No link(s) should appear on any website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights. You agree to indemnify, defend, and hold harmless GoValuate, its affiliates, and their respective officers, directors, employees, and agents from any claims, liabilities, damages, losses, and expenses, including legal fees, arising out of or in connection with your use of the site or violation of these Terms and Conditions.</p>
      </div>

      <div >
        <h2>8. Reservation of Rights</h2>
        <p>We reserve the right to request that you remove all links or any particular link to our Website. You agree to immediately remove all links to our Website upon request. We also reserve the right to amend these terms and conditions and its linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.</p>
      </div>

      <div >
        <h2 >9. Removal of Links from Our Website</h2>
        <p>If you find any link on our Website that is offensive for any reason, you are free to contact and inform us at any moment. We will consider requests to remove links but we are not obligated to do so or to respond to you directly.</p>
      </div>

      <div >
        <h2 >10. Disclaimer</h2>
        <p>To the maximum extent permitted by applicable law, we exclude all representations, warranties, and conditions relating to our website and the use of this website. Nothing in this disclaimer will:</p>
        <ul>
          <li>Limit or exclude our or your liability for death or personal injury;</li>
          <li>Limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li>
          <li>Limit any of our or your liabilities in any way that is not permitted under applicable law; or</li>
          <li>Exclude any of our or your liabilities that may not be excluded under applicable law.</li>
        </ul>
        <p>
        To the fullest extent permitted by applicable law, GoValuate, its affiliates, and their respective officers, directors, employees, and agents shall not be liable for any indirect, incidental, consequential, special, or punitive damages, or any loss of profits or data, whether in an action in contract, tort, or otherwise, arising out of or in connection with your use of the site or services.
        </p>
        <p>The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty.</p>
        <p>As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.</p>
      </div>
    </div>
    </div>
  );
};


export default TermsAndConditions;
